export default __webpack_public_path__ + "i18n/bg.297ffae9edf37a90e53925945aab3e5b.json";